import { render, staticRenderFns } from "./NumberOfVisits.vue?vue&type=template&id=3e0e8471&scoped=true&"
import script from "./NumberOfVisits.vue?vue&type=script&lang=js&"
export * from "./NumberOfVisits.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfVisits.vue?vue&type=style&index=0&id=3e0e8471&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e8471",
  null
  
)

export default component.exports